<template>
  <div class="flex items-center p-3 justify-between">
    <div class="w-full flex-grow">
      <div class="w-full flex justify-between items-center flex-grow">
        <div>
          <h5 class="font-medium leading-none">
            {{ form.form.title }}
          </h5>
          <p v-if="form.requestState" class="text-sm font-normal mt-1">
            <o-chip v-if="isRequestStateRequested" flat variant="warning" size="xs" square>
              {{ $t('form.requested') }}
            </o-chip>
            <o-chip v-if="isRequestStateCompleted" flat variant="success" size="xs" square>
              {{ $t('form.completed') }}
            </o-chip>
            <o-chip v-if="isRequestStateUpdateRequested" flat variant="warning" size="xs" square>
              {{ $t('form.updateRequested') }}
            </o-chip>
            <o-chip v-if="form.consentAccepted" flat variant="info" size="xs" square>
              {{ $t('form.consentAccepted') }}
            </o-chip>
            <o-chip v-if="isRequestStateScheduled" variant="warning" flat size="xs" square>
              {{ $t('general.colonSeparator', { label1: $t('general.scheduled'), label2: scheduledLabel }) }}
            </o-chip>
          </p>
        </div>

        <div class="flex items-center space-x-1">
          <o-button v-if="isRequestStateRequested || isRequestStateScheduled || (isRequestStateCompleted && !isFormStateLocked)" size="sm" flat @click="handleRequestUpdate()">
            {{ $t('general.request') }}
          </o-button>

          <o-tooltip v-if="!isFormStateLocked" :text="$t('form.fillInForm')">
            <o-panel-link
              tag="o-button"
              flat
              size="sm"
              :path="`/customer/form/${form.idCustomerForm}`"
              icon="edit"
            >
              {{ $t('general.edit') }}
            </o-panel-link>
          </o-tooltip>

          <o-tooltip v-if="!isRequestStateRequested && !isRequestStateScheduled" :text="$t('form.view')">
            <o-panel-link
              tag="o-button"
              flat
              size="sm"
              icon="view"
              :path="`/customer/form/view?id=${form.idCustomerForm}`"
            >
              {{ $t('general.view') }}
            </o-panel-link>
          </o-tooltip>
        </div>
      </div>
    </div>

    <request-update-dialog
      ref="requestUpdateDialog"
      :customerForm="form"
      :customer="reservation.customer"
      @success="handleSuccess()"
    />

    <request-form-dialog
      ref="requestFormDialog"
      :customer="reservation.customer"
      :reservation="reservation"
      :select="false"
      @success="handleSuccess()"
    />
  </div>
</template>

<script setup lang="ts">
import RequestUpdateDialog from '@/components/customerForm/actions/RequestUpdate.vue'
import RequestFormDialog from '@/components/customerForm/actions/Request.vue'

const { $date, $i18n, $bus } = useNuxtApp()

interface Props {
  form: Record<string, any>
  reservation: Record<string, any>
}

const props = defineProps<Props>()

const requestUpdateDialog = ref<any>()
const requestFormDialog = ref<any>()

const scheduledLabel = computed(() => {
  if (props.form.form.automationEnabled) {
    const date = new Date(props.form.scheduledTime * 1000)
    const utc = $date.utc(date)
    const format = $date.presets.full
    const label = $date.format(utc, format)

    return label
  } else {
    return $i18n.t('general.disabled')
  }
})

const isRequestStateNone = computed(() => props.form.isRequestStateNone)
const isRequestStateRequested = computed(() => props.form.isRequestStateRequested)
const isRequestStateCompleted = computed(() => props.form.isRequestStateCompleted)
const isRequestStateUpdateRequested = computed(() => props.form.isRequestStateUpdateRequested)
const isRequestStateScheduled = computed(() => props.form.isRequestStateScheduled)
const isFormStateLocked = computed(() => props.form.isFormStateLocked)

function handleRequestForm () {
  requestFormDialog.value.open(props.form.form)
}

function handleRequestUpdate () {
  requestUpdateDialog.value.open()
}

function handleSuccess () {
  $bus.emit.updated('Reservation', props.reservation)
}
</script>
